const STANDARD_SUB_OPTIONS = [
  { value: "add", label: "Add" },
  { value: "update", label: "Update" },
  { value: "delete", label: "Delete" },
];

export const permissionOptions = [
  {
    value: "user-management",
    label: "User Management",
    subOptions: STANDARD_SUB_OPTIONS,
  },
  {
    value: "course-management",
    label: "Course Management",
    subOptions: STANDARD_SUB_OPTIONS,
  },
  {
    value: "student-progress",
    label: "Student Progress",
    subOptions: STANDARD_SUB_OPTIONS,
  },
  {
    value: "manage-requests",
    label: "Manage Requests",
    subOptions: STANDARD_SUB_OPTIONS,
  },
  {
    value: "manage-payments",
    label: "Manage Payments",
    subOptions: STANDARD_SUB_OPTIONS,
  },
  {
    value: "activity-log",
    label: "Activity Log",
    subOptions: STANDARD_SUB_OPTIONS,
  },
  {
    value: "deletion-history",
    label: "Deletion History",
    subOptions: STANDARD_SUB_OPTIONS,
  },
  {
    value: "manage-plans",
    label: "Manage Plan",
    subOptions: STANDARD_SUB_OPTIONS,
  },
];
